// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2EMxs","title":"BackImages_title__3tfpk","images":"BackImages_images__1kcZF"};